import PodcastContainer from "./containers/PodcastContainer";
export default PodcastContainer;
